import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import AmountInput from '../../common/AmountInput';

const AmountComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Amount Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AmountInput
                                    name="primaryAmount"
                                    id="primaryAmountInput"
                                    required={true}
                                    layout="below"
                                    min={1}
                                    max={1000}
                                    showHelp={true}
                                    helpText="Please enter the primary amount."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AmountInput
    name="primaryAmount"
    id="primaryAmountInput"
    required={true}
    layout="below"
    min={1}
    max={1000}
    showHelp={true}
    helpText="Please enter the primary amount."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AmountInput
                                    name="businessAmount"
                                    id="businessAmountInput"
                                    required={true}
                                    layout="below"
                                    min={100}
                                    max={5000}
                                    showHelp={true}
                                    helpText="Please enter the business amount."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AmountInput
    name="businessAmount"
    id="businessAmountInput"
    required={true}
    layout="below"
    min={100}
    max={5000}
    showHelp={true}
    helpText="Please enter the business amount."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AmountInput
                                    name="optionalAmount"
                                    id="optionalAmountInput"
                                    required={false}
                                    layout="below"
                                    min={0}
                                    max={10000}
                                    placeholder="Enter optional amount"
                                    showHelp={true}
                                    helpText="This amount is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AmountInput
    name="optionalAmount"
    id="optionalAmountInput"
    required={false}
    layout="below"
    min={0}
    max={10000}
    placeholder="Enter optional amount"
    showHelp={true}
    helpText="This amount is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AmountInput
                                    name="secondaryAmount"
                                    id="secondaryAmountInput"
                                    required={true}
                                    layout="below"
                                    min={50}
                                    max={2500}
                                    showHelp={true}
                                    helpText="Please enter the secondary amount."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AmountInput
    name="secondaryAmount"
    id="secondaryAmountInput"
    required={true}
    layout="below"
    min={50}
    max={2500}
    showHelp={true}
    helpText="Please enter the secondary amount."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default AmountComponent;
